import { useEffect, useState } from "react";
import { useApp } from "@/store/AppStore";
import { formatCOP } from "@/utils/format";

const PRESETS = [8000, 10000, 12000, 15000, 18000];

const LogisticsConfig = () => {
  const { data, updateSettings } = useApp();
  const [fee, setFee] = useState(data.settings.logisticsFee);
  const [saved, setSaved] = useState(false);

  useEffect(() => setFee(data.settings.logisticsFee), [data.settings.logisticsFee]);

  const save = () => {
    updateSettings({ logisticsFee: Number(fee) || 0 });
    setSaved(true);
    setTimeout(() => setSaved(false), 1800);
  };

  return (
    <div className="glass-panel rounded-lg p-4 md:p-5">
      <div className="flex items-center gap-2 mb-3">
        <span className="w-8 h-8 rounded-md bg-primary-500/25 text-primary-100 flex items-center justify-center">
          <i className="ri-truck-line" />
        </span>
        <h3 className="editable-title text-base font-bold">Control Logístico de Transporte</h3>
      </div>
      <p className="text-[11px] text-foreground-500 mb-3">
        Fee de servicio logístico / envío desde Metrópolis. Se aplica a las entregas a domicilio.
      </p>

      <label className="block text-[11px] font-semibold text-foreground-600 mb-1">
        Fee de envío (COP)
      </label>
      <div className="flex flex-col sm:flex-row gap-2">
        <div className="relative flex-1">
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-foreground-500 text-sm">$</span>
          <input
            type="number"
            value={fee}
            onChange={(e) => setFee(Number(e.target.value) || 0)}
            className="w-full bg-background-100/70 border border-background-300/50 rounded-md pl-7 pr-3 py-2 text-sm text-foreground-950 outline-none focus:border-accent-500/50"
            aria-label="Fee logístico"
          />
        </div>
        <button
          onClick={save}
          className="px-4 py-2 rounded-md bg-primary-500 hover:bg-primary-600 text-foreground-950 text-sm font-semibold whitespace-nowrap cursor-pointer"
        >
          Guardar fee
        </button>
      </div>

      <div className="flex flex-wrap gap-2 mt-3">
        {PRESETS.map((p) => (
          <button
            key={p}
            onClick={() => setFee(p)}
            className={`px-2.5 py-1 rounded-full text-[11px] border cursor-pointer whitespace-nowrap ${
              fee === p
                ? "bg-accent-500/20 border-accent-500/40 text-accent-200"
                : "border-background-300/50 text-foreground-600 hover:border-accent-500/30"
            }`}
          >
            {formatCOP(p)}
          </button>
        ))}
      </div>

      {saved && (
        <p className="text-[11px] text-accent-300 mt-3 flex items-center gap-1.5 animate-fade-up">
          <i className="ri-checkbox-circle-line" /> Fee logístico actualizado correctamente.
        </p>
      )}
    </div>
  );
};

export default LogisticsConfig;